import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FunctionComponent, ReactNode, useState } from "react";
import AppLink from "../router/app-link";

export interface MenuItemProps {
  title: string | JSX.Element;
  href?: string;
  to?: string;
  className?: string;
  active?: boolean;
  fadeable?: boolean;
  icon?: IconProp;
  iconBgc?: string;
  children?: ReactNode;
  onShow: (isVisible: boolean) => void;
  onCollapse: (isVisible: boolean) => void;
}

const MenuItem: FunctionComponent<MenuItemProps> = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasChildren = !!props.children;
  const hasLink = !!props.to || !!props.href;

  const handleClick = (e?: React.MouseEvent) => {
    if (hasChildren && !hasLink) {
      e?.preventDefault();
      setIsExpanded(!isExpanded);
    }
    props.onShow(false);
    props.onCollapse(true);
  };

  const WrapperTag = props.to ? AppLink : props.href ? "a" : "div";
  const wrapperProps: any = props.to
    ? {
        to: props.to,
        className: `nav-link${hasChildren ? " dropdown-toggle" : ""}${
          isExpanded ? "" : " collapsed"
        }`,
        onClick: handleClick,
      }
    : props.href
    ? {
        href: props.href,
        className: `nav-link${hasChildren ? " dropdown-toggle" : ""}${
          isExpanded ? "" : " collapsed"
        }`,
        onClick: handleClick,
      }
    : {
        className: `nav-link${hasChildren ? " dropdown-toggle" : ""}${
          isExpanded ? "" : " collapsed"
        }`,
        onClick: handleClick,
      };

  return (
    <li
      className={`nav-item ${props.className || ""}${
        props.active ? " active" : ""
      }${isExpanded ? " open" : ""}`}
    >
      <WrapperTag {...wrapperProps}>
        {props.icon && (
          <FontAwesomeIcon
            icon={props.icon}
            className={`nav-icon nav-icon-round bgc-${props.iconBgc}`}
            size="lg"
            style={{ fontSize: "1rem" }}
          />
        )}
        <span className={`nav-text${props.fadeable ? " fadeable" : ""}`}>
          <span>{props.title}</span>
        </span>
        {hasChildren && (
          <b>
            <FontAwesomeIcon
              icon={isExpanded ? faAngleDown : faAngleLeft}
              className="caret"
            />
          </b>
        )}
      </WrapperTag>

      {hasChildren && (
        <div className={`hideable submenu${isExpanded ? "" : " collapse"}`}>
          <ul className="submenu-inner">{props.children}</ul>
        </div>
      )}
    </li>
  );
};

export default MenuItem;
